export default __webpack_public_path__ + "static/media/Sean McPherson.3be16826.png";